export default __webpack_public_path__ + "static/media/og-image.549bc6ad.jpg";